export enum ModalMessageType {
  CloseModal = "MODAL_CLOSE",
  InitializeProductRoleSelectCallback = "INIT_PRODUCT_ROLE_SELECT_CALLBACK",
}
